module.exports = __webpack_public_path__ + "static/media/hall-void.f4e319fe.svg";